<h2 mat-dialog-title>{{title}}</h2>
<div mat-dialog-content>
  <p>
    {{message}}
  </p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="onCancelClick()">{{cancelButtonText}}</button>
  <button mat-flat-button color="primary" mat-raised-button (click)="onConfirmClick()">{{confirmButtonText}}</button>
</div>
